import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgIcAddJob({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13 4.36h4.266c1.235 0 2.234 1.02 2.234 2.28v2.693h-4.875V8.297a.62.62 0 0 0-.61-.621.62.62 0 0 0-.609.621v1.036H6.094V8.297a.62.62 0 0 0-.61-.621.62.62 0 0 0-.609.621v1.036H0V6.64c0-1.26 1-2.28 2.234-2.28H6.5v-.828c0-.914.728-1.657 1.625-1.657h3.25c.896 0 1.624.743 1.624 1.658v.828Zm-4.875 0v-.828h3.25v.829h-3.25ZM19.5 12.488a.75.75 0 0 0-.33-.621Zm-.33-.621a.746.746 0 0 0-.64-.096.751.751 0 0 0-.53.717v3.75h-3.75a.75.75 0 0 0-.75.75.749.749 0 0 0 .75.75H18v3.75a.75.75 0 0 0 1.5 0v-3.75h3.75a.75.75 0 0 0 0-1.5H19.5v-3.75m-4.875-1.148v-.762h2.936a2.248 2.248 0 0 0-1.061 1.91v2.25h-2.25a2.25 2.25 0 0 0-1.71 3.713H2.234C1 18.45 0 17.43 0 16.17v-5.593h4.875v.762c0 .34.276.622.61.622a.62.62 0 0 0 .609-.622v-.762h7.312v.762c0 .34.276.622.61.622a.62.62 0 0 0 .609-.622Z"
                fill="#297A71"
            />
        </svg>
    )
}
SvgIcAddJob.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgIcAddJob
